import { catchError } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { AppSettingService } from '../services/app-setting.service';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ContactUsService  {
  constructor(private appSettingService : AppSettingService, public http: HttpClient) { }

  SubmitContactUs(model: any): Observable<any> {
      try {   
                   
          var body = JSON.stringify(model);

          return this.http
              .post(AppSettingService.contactUsUri, body)
              .pipe(catchError(this.error));
      } catch (error) {

      }
  }

  error(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(error);
    return throwError(errorMessage);
  }
}
